(function(){
    'use strict';

    angular
        .module('elogbooks')
        .config(registerRoutes);

    function registerRoutes($stateProvider) {

        $stateProvider
            .state('login', {
                abstract: true,
                url: "/login",
                template: '<ui-view/>',
                resolve: {
                    rootResource: function (apiClient, $rootScope, $window) {
                        return apiClient.get('/').then(function(response) {
                            $rootScope.theme = response?.theme;
                            $rootScope.iconLibrary = response?.iconLibrary;

                            // Persist SSO params for the Auth0 provider, which is
                            // configured in the config phase (before this call) and can
                            // only read them synchronously from localStorage. They take
                            // effect on the next page load. See src/app.config.js.
                            if (response?.ssoParams?.client_id && response?.ssoParams?.domain) {
                                $window.localStorage.setItem('ssoParameters', JSON.stringify(response.ssoParams));
                            }

                            return response;
                        });
                    }
                }
            })
            .state('login.step1', {
                url: '?destination&username',
                templateUrl: '/modules/common/login/loginStep1.html',
                controller: 'LoginStep1Controller',
                controllerAs: 'vm'
            })
            .state('login.step2', {
                url: "/continue?username&destination",
                templateUrl: '/modules/common/login/login.html',
                controller: 'LoginController',
                controllerAs: 'vm'
            })
            .state('login.sso-link-password', {
                url: '/sso/link',
                templateUrl: '/modules/common/login/sso-link-password.html',
                controller: 'SsoLinkPasswordController',
                controllerAs: 'vm'
            })
            .state('auth0-processing', {
                url: "/auth0/processing",
                template: '<div class="loader show">' +
                          '  <cafm-icon name="spinner" size="4x" pulse></cafm-icon>' +
                          '</div>'
            });
    }
})();
